import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../redux/initialState"
import { PayloadAction } from "@reduxjs/toolkit";
import {statusFilter} from "../types/index"

export const sliceKey = "adminMangmentState"

export const adminManagementSlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {
      setStatusFilter: (state, action: PayloadAction<statusFilter>) => {
        state.statusFilter = action.payload;
      }
  },
});

export const { reducer, actions } = adminManagementSlice
